var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Layout"
  }, _vm._l(_vm.layout, function (row, index) {
    return _c('div', {
      key: ("layout_row_" + index),
      staticClass: "Layout-row"
    }, [_vm._l(row, function (column, index2) {
      var _column$children, _column$blockProps3, _column$blockProps4, _column$blockProps5, _column$blockProps6, _column$blockProps7, _column$blockProps8, _column$blockProps9;
      return [column.children ? [_c('div', {
        key: ("layout_column_" + index + "_" + index2),
        staticClass: "Layout-column",
        class: [!_vm.isPhoneBreakpoint ? ("w-" + (column.size)) : '', _vm.hasOneChild(column.children) ? 'Layout-column--row' : '']
      }, [column !== null && column !== void 0 && column.sectionTitle || column !== null && column !== void 0 && column.sectionButton ? _c('div', {
        staticClass: "Layout-sectionHead",
        class: {
          'Layout-sectionHead--noChildren': !((_column$children = column.children) !== null && _column$children !== void 0 && _column$children.length)
        }
      }, [column !== null && column !== void 0 && column.sectionTitle ? _c('h2', {
        staticClass: "Layout-sectionTitle",
        attrs: {
          "aria-label": column.sectionTitle
        }
      }, [_vm._v(" " + _vm._s(column.sectionTitle) + " ")]) : _vm._e(), column !== null && column !== void 0 && column.sectionButton ? _c('rounded-button', {
        staticClass: "Layout-sectionButton",
        attrs: {
          "label": column === null || column === void 0 ? void 0 : column.sectionButton.label
        },
        on: {
          "buttonClicked": function ($event) {
            column === null || column === void 0 ? void 0 : column.sectionButton.handler();
          }
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._l(column.children, function (child, index3) {
        var _child$blockProps, _column$blockProps, _child$blockProps2, _column$blockProps2, _child$blockProps3, _child$blockProps4, _child$blockProps5, _child$blockProps6;
        return [!child.hidden ? _c('div', {
          key: ("layout_column_" + index + "_" + index2 + "_" + index3),
          staticClass: "Layout-row",
          class: {
            'Layout-row--fullHeight': child === null || child === void 0 ? void 0 : (_child$blockProps = child.blockProps) === null || _child$blockProps === void 0 ? void 0 : _child$blockProps.fullHeight
          }
        }, [_vm.isContentLoaded ? _c('block', {
          attrs: {
            "containerId": column === null || column === void 0 ? void 0 : (_column$blockProps = column.blockProps) === null || _column$blockProps === void 0 ? void 0 : _column$blockProps.containerId,
            "contentCentered": child === null || child === void 0 ? void 0 : (_child$blockProps2 = child.blockProps) === null || _child$blockProps2 === void 0 ? void 0 : _child$blockProps2.contentCentered,
            "keepScroll": column === null || column === void 0 ? void 0 : (_column$blockProps2 = column.blockProps) === null || _column$blockProps2 === void 0 ? void 0 : _column$blockProps2.keepScroll,
            "menuOptions": child === null || child === void 0 ? void 0 : (_child$blockProps3 = child.blockProps) === null || _child$blockProps3 === void 0 ? void 0 : _child$blockProps3.menuOptions,
            "title": child === null || child === void 0 ? void 0 : (_child$blockProps4 = child.blockProps) === null || _child$blockProps4 === void 0 ? void 0 : _child$blockProps4.title,
            "titleInfos": child === null || child === void 0 ? void 0 : (_child$blockProps5 = child.blockProps) === null || _child$blockProps5 === void 0 ? void 0 : _child$blockProps5.titleInfos,
            "withoutPadding": child === null || child === void 0 ? void 0 : (_child$blockProps6 = child.blockProps) === null || _child$blockProps6 === void 0 ? void 0 : _child$blockProps6.withoutPadding
          }
        }, [_c(child.component, {
          tag: "component",
          attrs: {
            "infos": child.props
          }
        })], 1) : _c('div', {
          staticClass: "ContentLoader Layout-loaderBlock",
          class: _vm.hasOneChild(column.children) ? '' : 'Layout-loaderBlock--half'
        })], 1) : _vm._e()];
      })], 2)] : !column.hidden ? _c('div', {
        key: ("layout_column_" + index + "_" + index2),
        staticClass: "Layout-column",
        class: !_vm.isPhoneBreakpoint ? ("w-" + (column.size)) : ''
      }, [column !== null && column !== void 0 && column.sectionTitle || column !== null && column !== void 0 && column.sectionButton ? _c('div', {
        staticClass: "Layout-sectionHead"
      }, [column !== null && column !== void 0 && column.sectionTitle ? _c('h2', {
        staticClass: "Layout-sectionTitle",
        attrs: {
          "aria-label": column.sectionTitle
        }
      }, [_vm._v(" " + _vm._s(column.sectionTitle) + " ")]) : _vm._e(), column !== null && column !== void 0 && column.sectionButton ? _c('rounded-button', {
        staticClass: "Layout-sectionButton",
        attrs: {
          "label": column === null || column === void 0 ? void 0 : column.sectionButton.label
        },
        on: {
          "buttonClicked": function ($event) {
            column === null || column === void 0 ? void 0 : column.sectionButton.handler();
          }
        }
      }) : _vm._e()], 1) : _vm._e(), _vm.isContentLoaded ? _c('block', {
        class: {
          'Layout-forceHeight': column.size !== 100
        },
        attrs: {
          "containerId": column === null || column === void 0 ? void 0 : (_column$blockProps3 = column.blockProps) === null || _column$blockProps3 === void 0 ? void 0 : _column$blockProps3.containerId,
          "contentCentered": column === null || column === void 0 ? void 0 : (_column$blockProps4 = column.blockProps) === null || _column$blockProps4 === void 0 ? void 0 : _column$blockProps4.contentCentered,
          "keepScroll": column === null || column === void 0 ? void 0 : (_column$blockProps5 = column.blockProps) === null || _column$blockProps5 === void 0 ? void 0 : _column$blockProps5.keepScroll,
          "menuOptions": column === null || column === void 0 ? void 0 : (_column$blockProps6 = column.blockProps) === null || _column$blockProps6 === void 0 ? void 0 : _column$blockProps6.menuOptions,
          "title": column === null || column === void 0 ? void 0 : (_column$blockProps7 = column.blockProps) === null || _column$blockProps7 === void 0 ? void 0 : _column$blockProps7.title,
          "titleInfos": column === null || column === void 0 ? void 0 : (_column$blockProps8 = column.blockProps) === null || _column$blockProps8 === void 0 ? void 0 : _column$blockProps8.titleInfos,
          "withoutPadding": column === null || column === void 0 ? void 0 : (_column$blockProps9 = column.blockProps) === null || _column$blockProps9 === void 0 ? void 0 : _column$blockProps9.withoutPadding
        }
      }, [_c(column.component, {
        tag: "component",
        attrs: {
          "infos": column.props
        }
      })], 1) : _c('div', {
        staticClass: "ContentLoader Layout-loaderBlock",
        class: {
          'Layout-forceHeight': column.size !== 100
        }
      })], 1) : _vm._e()];
    })], 2);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }